<template>
  <!-- 微课评比 -->
  <div>
    <vsmallheader></vsmallheader>
    <div class="metter-box">
      <div
        style="font-size: 14px; color: #888; display: flex; align-items: center"
      >
        <img
          src="@/assets/resource/adresst.png"
          style="width: 15px; height: 15px; margin-right: 5px"
        />
        当前位置：
      </div>
      <span style="cursor: pointer;font-size: 14px;" @click="retrun">个人中心</span> /
      <span style="cursor: pointer;font-size: 14px;" @click="retrun">活动评分列表</span>
    </div>
    <div class="classbox">
        <workscoring :GradeId="GradeId"></workscoring>
    </div>
  </div>
</template>
<script>
import vsmallheader from '@/views/smallHeader/index';
import linecom from '@/components/linecom/index';
import workscoring from './component/component/workscoring';
export default {
  components: {
    vsmallheader,
    linecom,
    workscoring
  },
  data() {
    return {
      GradeId:null,

    };
  },
  created() {
    this.GradeId=this.$route.query.id
  },
  methods: {
    retrun() {
      this.$router.go(-1);
    },

  },
};
</script>
<style scoped>
.heightli {
  color: rgb(130, 235, 26) !important;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.stepss {
  display: flex;
  margin: 10px 0;
  border-bottom: solid 1px #f2f2f2;
}
.stepss > div {
  width: 240px;
  height: 30px;
  text-align: center;
  font-size: 18px;
  color: #aaa;
}
.classbox {
  margin: 0 auto;
  width: 1200px;
  min-height: 700px;
  margin-bottom: 30px;
  padding: 0 10px;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 97%);
}
.classheader {
  padding: 20px;
  height: 210px;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
  border-radius: 5px;
  margin-top: 20px;
}
.classheader1 {
  display: flex;
  align-items: center;
}
.classheader1 > div:nth-child(1) {
  flex: 1;
  font-size: 20px;
}
.classheader1 > div:nth-child(2) {
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  padding: 0 8px;
  font-size: 18px;
  cursor: pointer;
  color: #fff;
  background-color: rgb(247, 166, 16);
  margin-left: 20px;
}
.classheader2 {
  display: flex;
}
.hdTitleBox {
  box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
  border-radius: 5px;
  margin-top: 20px;
}
.hdTitleii {
  height: 23px;
  width: 3px;
  background-color: #1492ff;
  margin-right: 15px;
}
.hdTitle {
  display: flex;
  align-items: center;
  font-size: 20px;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 0 10px 10px;
}
.headerfirst {
  flex: 1;
}
.headerfirst > div {
  line-height: 50px;
  font-size: 16px;
  color: #555;
}
.classjindu {
  width: 1200px;
  margin: 0 auto;

  margin-bottom: 20px;
  min-height: 450px;
}
.ageleft {
  width: 900px;
  /* height: 200px; */
  background-color: #fff;
  box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
}
.lable {
  width: 900px;
  height: 40px;
  border-bottom: solid 1px #ccc;
  margin: 0 auto;
  padding-top: 10px;
  display: flex;
}
.lable > div {
  flex: 1;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
}
.lable > div:hover {
  color: #409eff;
}
.heightlight {
  color: #409eff !important;
  font-weight: 700;
}
.xian {
  width: 150px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.stepmessage {
  padding: 10px 20px;
  padding-bottom: 40px;
  font-size: 16px;
}
.stepmessage > div:nth-child(1) > div:nth-child(odd) {
  padding-left: 10px;
  color: #333;
  border-left: solid 3px #1492ff;
  margin-top: 15px;
}
.stepmessage > div:nth-child(1) > div:nth-child(even) {
  font-size: 16px;
  padding-left: 10px;
  color: #555;
  text-indent: 30px;
  margin-top: 10px;
}
.dialogheader {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
}
.dialogForm {
  width: 90%;
  margin-top: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.metter-box {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;
}
</style>
